import useSiteSettings from "@/hooks/useSiteSettings";
import { Heart } from "lucide-react";

const PORTLAND_IMG = "https://static.prod-images.emergentagent.com/jobs/80c9f69f-e76a-468f-8586-36a8efaab5df/images/2568a50f1a798e5701f8c882f57f5adb43832dca42a5136639466ef688995ff4.png";

export default function About() {
  const { settings } = useSiteSettings();
  const a = settings.about;

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative overflow-hidden bg-[#FDF9F3] py-20 lg:py-28 px-6 lg:px-12"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-6">
          <div className="font-hand text-2xl text-[#A67F4E] mb-2">the story</div>
          <h2
            data-testid="about-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#3D2E1C] leading-[1.05] mb-8"
          >
            {a.title_line1}
            <br />
            <span className="text-[#A67F4E] font-hand text-5xl sm:text-6xl italic">
              {a.title_line2}
            </span>
          </h2>

          <div className="space-y-5 text-[#3D2E1C]/75 leading-relaxed">
            <p data-testid="about-p1">{a.paragraph1}</p>
            <p data-testid="about-p2">{a.paragraph2}</p>
          </div>

          <div className="mt-8 inline-flex items-center gap-3 p-4 pr-6 bg-[#F5EBD9] rounded-2xl">
            <Heart className="w-5 h-5 text-[#A67F4E] fill-[#A67F4E]" strokeWidth={2} />
            <div>
              <div className="font-bold text-[#3D2E1C] text-sm">Portland teens · locally owned</div>
              <div className="text-xs text-[#7A6A55]">Every booking helps us grow the business.</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative mb-8 rounded-3xl overflow-hidden">
            <img src={PORTLAND_IMG} alt="Portland" className="w-full h-64 object-cover" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            {(a.stats || []).slice(0, 4).map((s, i) => (
              <div
                key={i}
                data-testid={`stat-${i}`}
                className="p-6 bg-white border-2 border-[#E9DFCB] rounded-2xl hover:border-[#D6B98D] transition-colors"
              >
                <div className="font-serif text-4xl text-[#3D2E1C] font-bold">{s.number}</div>
                <div className="mt-1 text-xs font-semibold uppercase tracking-wide text-[#7A6A55]">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
